import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import style from './style';
import classNames from 'classnames/bind';
import { hide as hideDialog } from './actions';

const classnames = classNames.bind(style);

export default class ModalDialog extends React.PureComponent {

    static displayName = '[component] ModalDialog';

    hide = (e) => {
        e.preventDefault();
        hideDialog(this.props.dispatch)
    };

    render() {
        let result = null;

        const { msg, show, title } = this.props;

        if(show && msg) {
            result = (
                <Fragment>
                    <div
                        className={classnames('modal__overlay', 'modal__overlay_show')}
                        onClick={this.hide}
                    />
                    <div
                        className={classnames('modal__dialog', 'modal__dialog_show')}
                    >
                        <div className={style['modal__content']}>
                            <div className={style['modal__header']}>
                                <button type="button" onClick={this.hide} className={style['modal__close']}>×</button>
                                <h3 className={style['modal__title']}>{title}</h3>
                            </div>
                            <div className={style['modal__body']}>
                                {msg}
                            </div>
                            <div className={style['modal__actions']}>
                                <button type="button" onClick={this.hide} className={style['modal__actions_button']}>OK</button>
                            </div>
                        </div>

                    </div>
                </Fragment>);
        }

        return result;
    }

}

ModalDialog.propTypes = {
    msg     : PropTypes.string,
    title   : PropTypes.string,
    show    : PropTypes.bool,
    dispatch: PropTypes.func.isRequired
};

ModalDialog.defaultProps = {
    msg  : '',
    title: '',
    show : false
};



// WEBPACK FOOTER //
// ./src/blocks/modal-dialog/ModalDialog.js